export const formatUrlNoScheme = (url?: string): string | undefined => {
  if (url) {
    return url.replace(RegExp('/http|https?://'), '');
  }
};
